import React from "react";



export default function PendingFee() {
    return (
        <div>
            <h4><b>Pending Fees Info</b></h4>
        </div>
    )
}
